// extracted by mini-css-extract-plugin
export var borderRadius = "_5y-4";
export var large = "_5y-3";
export var logoContainer = "_5y-0";
export var nameLogo = "_5y-2";
export var small = "_5y-1";